import { captureException } from "@sentry/vue"
import { takeIfNotEmpty } from "./take-if"

export function setStoredValue(key: string, value: string) {
  try {
    localStorage.setItem(key, value)
  } catch (e) {
    captureException(e)
  }
}

export function getStoredValue(key: string): string | undefined {
  try {
    return localStorage.getItem(key) ?? undefined
  } catch (e) {
    captureException(e)
    return undefined
  }
}

export function setStoredBooleanValue(key: string, value: boolean) {
  try {
    localStorage.setItem(key, value.toString())
  } catch (e) {
    captureException(e)
  }
}

const BOOLEAN_FALSE_VALUES = ["false", "no", "0"]

export function getStoredBooleanValue(key: string): boolean | undefined {
  try {
    const storedValue = localStorage.getItem(key)
    return storedValue ? (storedValue.length > 0 && !BOOLEAN_FALSE_VALUES.includes(storedValue)) : undefined
  } catch (e) {
    captureException(e)
    return undefined
  }
}

export function setStoredValues(key: string, value: string[], separator: string = ',') {
  try {
    localStorage.setItem(key, value.join(separator))
  } catch (e) {
    captureException(e)
  }
}

export function getStoredValues(key: string, separator: string = ','): string[] | undefined {
  try {
    return takeIfNotEmpty(localStorage.getItem(key)?.split(separator)?.map(s => s.trim())?.filter(s => !!s)) ?? undefined
  } catch (e) {
    captureException(e)
    return undefined
  }
}
